import { useMemo } from 'react';
import { useWindowSize } from './useWindowSize';
import { useDebounce } from './useDebounce';

export function useEntityFormMaxHeight(id: string = 'form') {
  const windowSize = useWindowSize();
  const windowSizeD = useDebounce(windowSize);
  const maxHeight = useMemo(() => {
    return window.innerHeight - (document.getElementById(id)?.getBoundingClientRect().top || 0);
  }, [windowSizeD, document.getElementById(id)]);
  return maxHeight;
}
